module.exports = __webpack_public_path__ + "img/echeck.25865a28.gif";